import { useLocation, useNavigate } from 'react-router-dom';
import CandleStickChart from '../../components/TraderChart/Traderchart';
import TradeDetailsCard from '../../components/Accountmetrics/TradeDetailsCard';
import './style.scss'
import { useState } from 'react';


const TradeDetailsPage = () => {
    const { state } = useLocation();
    const {
        positionInfo,
        period,
        selectedTradeDate,
        candleStickSymbol,
        candleStickTime,
        positions,
    } = state || {};

    const [active, setActive] = useState('1d');
    const [period1, setPeriod1] = useState(period)
    const navigate = useNavigate();
    const [renderInfo, setRenderInfo] = useState(false);

    const [candleStickSymbol1, setCandleStickSymbol1] = useState(candleStickSymbol);
    const [candleStickTime1, setCandleStickTime1] = useState(candleStickTime);
    const [activeTimeFrame, setActiveTimeFrame] = useState('one_minute');
    const [info,setInfo] = useState(positionInfo)

    console.log(info, 'activeTimeFrameactiveTimeFrame');

    const dateRanges = [
        { label: '1D', value: '1d' },
        { label: '1W', value: '1w' },
        { label: '1M', value: '1m' },
        { label: '3M', value: '3m' },
        { label: '6M', value: '6m' },
        { label: '1Y', value: '1y' },
    ];


    const timeFrames = {
        '1d': [
            {
                time: '1m',
                value: 'one_minute'
            },
            {
                time: '5m',
                value: 'five_minute'
            },
            {
                time: '15m',
                value: 'fifteen_minute'
            },
            {
                time: '30m',
                value: 'thirty_minute'
            },
            {
                time: '1h',
                value: 'one_hour'
            },
            {
                time: '3h',
                value: 'three_hour'
            }
        ],
        '1w': [
            {
                time: '1h',
                value: 'one_hour'
            },
            {
                time: '3h',
                value: 'three_hour'
            },
            {
                time: '6h',
                value: 'six_hour'
            },
            {
                time: '12h',
                value: 'tweelve_hour'
            },
            {
                time: '1d',
                value: 'one_day'
            }
        ],
        '1m': [
            {
                time: '1d',
                value: 'one_day'
            },
            {
                time: '1w',
                value: 'weekly'
            }
        ],
        '3m': [
            {
                time: '1d',
                value: 'one_day'
            },
            {
                time: '1w',
                value: 'weekly'
            },
            {
                time: '1m',
                value: 'monthly'
            }
        ],
        '6m': [
            {
                time: '1d',
                value: 'one_day'
            },
            {
                time: '1w',
                value: 'weekly'
            },
            {
                time: 'monthly'
            }
        ],
        '1y': [
            {
                time: '1d',
                value: 'one_day'
            },
            {
                time: '1w',
                value: 'weekly'
            },
            {
                time: '1m',
                value: 'monthly'
            }
        ]
    }

    const calculateDates = (period, storedDate) => {
        const storedDateObj = new Date(storedDate);
        if (isNaN(storedDateObj.getTime())) {
            throw new Error("Invalid stored date");
        }

        let startDate = new Date(storedDateObj);
        let endDate = new Date(storedDateObj);

        switch (period) {
            case '1d':
                break; // No change
            case '1w':
                startDate.setDate(startDate.getDate() - 3);
                endDate.setDate(endDate.getDate() + 3);
                break;
            case '1m':
                startDate.setMonth(startDate.getMonth() - 1);
                endDate.setMonth(endDate.getMonth() + 1);
                break;
            case '3m':
                startDate.setMonth(startDate.getMonth() - 3);
                endDate.setMonth(endDate.getMonth() + 3);
                break;
            case '6m':
                startDate.setMonth(startDate.getMonth() - 6);
                endDate.setMonth(endDate.getMonth() + 6);
                break;
            case 'ytd':
                startDate = new Date(storedDateObj.getFullYear(), 0, 1);
                endDate = new Date(storedDateObj);
                break;
            case '1y':
                startDate.setFullYear(startDate.getFullYear() - 1);
                endDate.setFullYear(endDate.getFullYear() + 1);
                break;
            default:
                startDate = new Date(0);
                endDate = new Date();
                break;
        }

        return {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
        };
    };


    const handleClick = (value) => {
        setActive(value);

        const { startDate, endDate } = calculateDates(value, selectedTradeDate);
        setPeriod1({
            start_date: startDate,
            end_date: endDate
        })
        if (value !== '1d') {
            setCandleStickTime1(null)
        }
        if (value == '1d') {
            setCandleStickTime1(selectedTradeDate)
        }
        setActiveTimeFrame(timeFrames?.[value]?.[0]?.value)
    };

    return (
        <div className='view-trade-container'>
            <div className="candleChartHeader">
                <div className="candle-chart-filter">

                    {dateRanges?.map((range, index) => (
                        <button
                            key={index}
                            className={`range-button ${active === range.value ? 'active' : ''}`}
                            onClick={() => handleClick(range.value)}
                        >
                            {range.label}
                        </button>
                    ))}
                </div>
                {
                    active && (
                        <div className="time-frame-filters">
                            {timeFrames?.[active]?.map((timeFrame, index) => {
                                return (
                                    <div key={index} className={`${activeTimeFrame === timeFrame?.value ? 'active-time-frame' : ''}`} onClick={() => setActiveTimeFrame(timeFrame?.value)}>{timeFrame?.time}</div>
                                )
                            })}
                        </div>
                    )
                }

                <button className="close-button" onClick={() => {

                    setCandleStickTime1(null);
                    setCandleStickSymbol1(null);
                    setActive('1d')
                    navigate('/AccountMetric')

                }}>
                    ×
                </button>
            </div>
            <CandleStickChart
                period={period1}
                selectedDate={selectedTradeDate}
                symbol={candleStickSymbol}
                candleStickTime={candleStickTime1}
                positions={positions}
                setPositionInfo={setInfo}
                color={info?.info?.[1]?.profit > 0 ? 'green' : 'red'}
                activeTimeFrame={activeTimeFrame}
                setRenderInfo={setRenderInfo}
                 
            />
            {
                renderInfo && (
                    <TradeDetailsCard
                        trade={
                            info?.first
                                ? info?.info?.[0]
                                : info?.info?.[1]
                        }
                    />
                )
            }
        </div>
    );
};

export default TradeDetailsPage;
